// Store en memoria del intervalo de slots para el simulador (sin backend).
// Espeja settings.slot_interval_minutes de la empresa real.
const ALLOWED = [5, 10, 15, 20, 30, 40, 45, 60];
let interval = 15;

export function getSlotInterval() {
  return interval;
}

export function setSlotInterval(n) {
  const v = Number(n);
  interval = ALLOWED.includes(v) ? v : 15;
}
